'use strict';

(function (moment) {
	angular.module('pmtPlacesApp.directives').directive('pmtLocationEditTemporarilyClosed', [
		'$stateParams',
		'LocationEditService',
		'pmtSpecialOpenHourValidationService',
		function ($stateParams, LocationEditService, pmtSpecialOpenHourValidationService) {
			return {
				restrict: 'A',
				replace: true,
				scope: {
					place: '=pmtLocationEditTemporarilyClosed',
					onUpdate: '<',
					onClose: '&',
					openDialog: '=',
					setMultiple: '='
				},
				link: function (scope) {
					scope.siteName = $stateParams.site;
					scope.selectedLocations = [];
					scope.onSelectedLocations = locations => {
						scope.selectedLocations = locations;
						scope.$apply();
					};

					scope.minDate = pmtSpecialOpenHourValidationService.DATE_TOMORROW;
					scope.maxDate = pmtSpecialOpenHourValidationService.MAX_DATE;
					scope.updatePlace = {};

					scope.onMomentPickerChange = newValue => {
						if (newValue != null) {
							scope.updatePlace.temporarilyClosedUntil = newValue.format('YYYY-MM-DD');
						}
					};

					const setModel = function () {
						if (!scope.place) {
							scope.updatePlace.isTempClosed = true;
						}
						scope.updatePlace.isTempClosed =
							scope.place &&
							scope.place.temporarilyClosedUntil &&
							scope.place.temporarilyClosedUntil.length > 0
								? true
								: false;

						scope.updatePlace.temporarilyClosedMessage = scope.updatePlace.isTempClosed
							? scope.place.temporarilyClosedMessage
							: '';

						if (scope.setMultiple) {
							scope.updatePlace.isTempClosed = true;
							scope.momentToString(scope.stringToMoment(null));
						} else {
							scope.momentToString(scope.place.temporarilyClosedUntil);
						}
					};

					scope.placeUpdated = function (data) {
						if (!scope.setMultiple) {
							angular.extend(scope.place, data.place);
							scope.onUpdate(data.workId, data.place);
						}
						scope.openDialog = false;
						scope.displayLocationSelector = false;
					};

					scope.errorUpdatePlace = function () {
						scope.showErrorSaving = true;
						scope.showSavingProgress = false;
						scope.displayLocationSelector = false;
					};

					scope.isDisabled = () => scope.selectedLocations?.length < 1;

					scope.updateAll = function () {
						if (scope.setMultiple) {
							scope.openDialog = false;
							scope.onClose();
						} else {
							scope.showSavingProgress = true;
							LocationEditService.updateAllPartial(
								scope.siteName,
								scope.place._id,
								scope.updatePlace
							).then(scope.placeUpdated, scope.errorUpdatePlace);
						}
					};

					scope.save = function () {
						const updateTempClosed = scope.updatePlace
							? scope.updatePlace.temporarilyClosedUntil
							: '';
						const placeTempClosed = scope.place ? scope.place.temporarilyClosedUntil : '';
						if (
							scope.place &&
							scope.updatePlace &&
							(updateTempClosed !== placeTempClosed ||
								scope.updatePlace.temporarilyClosedMessage !== scope.place.temporarilyClosedMessage)
						) {
							scope.showSavingProgress = true;
							if (!scope.updatePlace.temporarilyClosedUntil) {
								scope.updatePlace.temporarilyClosedUntil = '';
							}
							if (!scope.updatePlace.temporarilyClosedMessage) {
								scope.updatePlace.temporarilyClosedMessage = '';
							}
							LocationEditService.savePartial(
								scope.siteName,
								scope.place._id,
								scope.updatePlace
							).then(scope.placeUpdated, scope.errorUpdatePlace);
						} else {
							scope.openDialog = false;
							scope.onClose();
						}
					};

					scope.cancel = function () {
						scope.displayLocationSelector = false;
						scope.selectedLocations = [];
						scope.updatePlace = {};
						scope.openDialog = false;
						scope.onClose();
					};

					scope.$watch('openDialog', function (newVal) {
						if (newVal) {
							scope.selectedLocations = scope.place?._id ? [scope.place._id] : [];
							scope.displayLocationSelector = false;
							scope.showSavingProgress = false;
							scope.showErrorSaving = false;
							setModel();
						}
					});

					scope.$watch('displayLocationSelector', function (newVal) {
						if (newVal) {
							scope.openDialog = false;
							scope.onClose();
						}
					});

					scope.toggle = () => {
						if (scope.updatePlace.isTempClosed) {
							const date = scope.stringToMoment(scope.place.temporarilyClosedUntil);
							scope.momentToString(date);
						} else {
							scope.updatePlace.temporarilyClosedUntil = '';
							scope.updatePlace.temporarilyClosedMessage = '';
						}
					};

					scope.momentToString = val => {
						const formattedDate = moment(val).format('YYYY-MM-DD');
						scope.updatePlace.temporarilyClosedUntil = formattedDate;
					};

					scope.stringToMoment = val => {
						if (moment(val, 'YYYY-MM-DD').isValid()) {
							return moment(val, 'YYYY-MM-DD');
						}
						return moment(new Date());
					};
				},
				templateUrl:
					'shared/location/edit/temporarilyClosed/pmtLocationEditTemporarilyClosedView.html'
			};
		}
	]);
})(window.moment);
